<app-header [currentModule]="moduloEnum" [currentModuleFuncionality]="funcionalidadeEnum"></app-header>

<div class="container-header">
    <div class="container-header-inner">
        @if (isLoading) {
        <div class="skeleton-container">
            <div class="d-flex flex-column gap-3">
                <app-loading-box width="300" height="28"></app-loading-box>
                <app-loading-box width="500" height="20"></app-loading-box>
                <app-loading-box width="200" height="36"></app-loading-box>
                <app-loading-box width="100%" height="1"></app-loading-box>
                <app-loading-box width="350" height="24"></app-loading-box>
                <app-loading-box width="500" height="20"></app-loading-box>
                <div class="d-flex gap-3">
                    <app-loading-box width="200" height="56"></app-loading-box>
                    <app-loading-box width="400" height="56"></app-loading-box>
                    <app-loading-box width="120" height="40"></app-loading-box>
                </div>
                <div class="d-flex justify-content-between p-3 border rounded">
                    <app-loading-box width="80" height="20"></app-loading-box>
                    <app-loading-box width="300" height="20"></app-loading-box>
                    <app-loading-box width="40" height="20"></app-loading-box>
                </div>
            </div>
        </div>
        } @else {
        <div class="title-wrapper">
            <div>
                <h1 class="title-default">Configurações NFC-e</h1>
                <p class="welcome-message">
                    <button mat-icon-button (click)="cancelar()">
                        <mat-icon>arrow_back</mat-icon>
                    </button>
                    Configurações e preferências da NFC-e.
                </p>
            </div>
        </div>

        <div class="row section-separator">
            <div class="col-12">
                <p class="description-text small">
                    Informe o ID CSC e o Token CSC fornecidos pela SEFAZ para emissão de NFC-e.
                </p>
            </div>
            <div class="col-md-2 field-with-validation">
                <mat-form-field appearance="outline">
                    <mat-label>ID CSC</mat-label>
                    <input matInput type="text" [(ngModel)]="idCsc" (ngModelChange)="onIdCscChange($event)" name="idCsc"
                        #idCscModel="ngModel" inputmode="numeric" maxlength="6" required pattern="^[0-9]{6}$"
                        (keydown)="bloquearNaoNumerico($event)" />
                    @if (deveExibirIdCscErro()) {
                    <mat-error>{{ idCscError }}</mat-error>
                    }
                </mat-form-field>
            </div>
            <div class="col-md-6 field-with-validation">
                <mat-form-field appearance="outline">
                    <mat-label>Token CSC</mat-label>
                    <input matInput type="text" [(ngModel)]="tokenCsc" (ngModelChange)="onTokenCscChange()" name="tokenCsc"
                        #tokenCscModel="ngModel" required minlength="6" pattern="^\S+$" />
                    @if (deveExibirTokenCscErro()) {
                    <mat-error>{{ tokenCscError }}</mat-error>
                    }
                </mat-form-field>
            </div>
        </div>

        <div class="row section-separator">
            <div class="col-12">
                <div class="toggle-content">
                    <mat-slide-toggle class="app-toggle-compact" [checked]="emitirNFCeRejeitadaEmContingencia"
                        (change)="onToggleChange($event.checked)" color="primary">
                        Emitir automaticamente em contingência as NFC-es rejeitadas
                    </mat-slide-toggle>
                    <span class="info-text">Quando ativado, o sistema emitirá automaticamente em contingência as NFC-es rejeitadas durante o processo de emissão normal.<br>
                        (Exceto para os códigos de rejeições informados na lista de exceções abaixo)
                    </span>
                </div>
            </div>
        </div>

        @if (emitirNFCeRejeitadaEmContingencia) {
        <div class="section-container">
            <div class="add-excecao-row">
                <p class="section-description">
                    Adicione os códigos de rejeição que NÃO devem ser considerados para a emissão automática em contingência.
                </p>
                <button type="button" mat-button (click)="adicionarExcecao()"
                    [disabled]="!emitirNFCeRejeitadaEmContingencia">
                    <mat-icon>add</mat-icon>
                    Adicionar
                </button>
            </div>

            @if (excecoes.length > 0) {
            <table mat-table [dataSource]="excecoes" class="excecoes-table desktop-view">
                <ng-container matColumnDef="codigoRejeicao">
                    <th mat-header-cell *matHeaderCellDef>Código</th>
                    <td mat-cell *matCellDef="let row; let i = index">
                        <mat-form-field appearance="outline" class="inline-field inline-field-codigo">
                            <input matInput type="number" [(ngModel)]="row.codigoRejeicao"
                                placeholder="Ex: 778" max="9999" min="1"
                                (keydown)="bloquearNaoNumerico($event)"
                                (input)="limitarCodigoRejeicao($event, i)">
                        </mat-form-field>
                    </td>
                </ng-container>

                <ng-container matColumnDef="descricaoRejeicao">
                    <th mat-header-cell *matHeaderCellDef>Descrição</th>
                    <td mat-cell *matCellDef="let row">
                        <mat-form-field appearance="outline" class="inline-field inline-field-descricao">
                            <input matInput type="text" [(ngModel)]="row.descricaoRejeicao"
                                placeholder="Ex: Informado NCM inexistente">
                        </mat-form-field>
                    </td>
                </ng-container>

                <ng-container matColumnDef="acoes">
                    <th mat-header-cell *matHeaderCellDef class="col-acoes">Ações</th>
                    <td mat-cell *matCellDef="let row; let i = index" class="col-acoes">
                        <button mat-icon-button (click)="removerExcecao(i)"
                            matTooltip="Remover exceção"
                            [disabled]="!emitirNFCeRejeitadaEmContingencia">
                            <span class="material-symbols-outlined">delete</span>
                        </button>
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>

            <div class="mobile-view">
                @for (row of excecoes; track $index; let i = $index) {
                <div class="card-mobile mb-3">
                    <div class="card-header-mobile d-flex justify-content-between align-items-center">
                        <strong class="text-bold">Exceção #{{ i + 1 }}</strong>
                        <button type="button" mat-icon-button (click)="removerExcecao(i)"
                            matTooltip="Remover exceção"
                            [disabled]="!emitirNFCeRejeitadaEmContingencia">
                            <span class="material-symbols-outlined">delete</span>
                        </button>
                    </div>
                    <div class="card-body-mobile p-3">
                        <div class="mb-3">
                            <mat-form-field appearance="outline" class="w-100">
                                <mat-label>Código</mat-label>
                                <input matInput type="number" [(ngModel)]="row.codigoRejeicao"
                                    placeholder="Ex: 778" max="9999" min="1"
                                    (keydown)="bloquearNaoNumerico($event)"
                                    (input)="limitarCodigoRejeicao($event, i)">
                            </mat-form-field>
                        </div>
                        <div>
                            <mat-form-field appearance="outline" class="w-100">
                                <mat-label>Descrição</mat-label>
                                <input matInput type="text" [(ngModel)]="row.descricaoRejeicao"
                                    placeholder="Ex: Informado NCM inexistente">
                            </mat-form-field>
                        </div>
                    </div>
                </div>
                }
            </div>
            } @else {
            <app-empty-state
                icon="info_outline"
                title="Nenhuma exceção cadastrada"
                subtitle="Clique em Adicionar para incluir uma."></app-empty-state>
            }
        </div>
        }
        }    
    </div>
</div>

<app-footer-action [isLoadingSalvar]="isLoadingSalvar" (cancelar)="cancelar()" (salvar)="salvar()">
</app-footer-action>
